import {Stack, styled} from '@mui/material';

export const GridContainer = styled(Stack)(({theme}) => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	columnGap: theme.spacing(3),
	rowGap: theme.spacing(3),
	[theme.breakpoints.up('sm')]: {
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
	},
}));

export const IconWrapper = styled(Stack)(({theme}) => ({
	flexShrink: 0,
	paddingTop: theme.spacing(0.25),
}));
